<template>
  <div class="d-flex justify-content-center align-items-center paypro"></div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
export default {
  name: "Support",

  components: {
    Slick
  },
  data() {
    return {};
  },
  mounted() {
    this.$root.$emit("bv::show::modal", "support");
  }
};
</script>

<style>
/* .modal-bg {
  width: 100%;
  position: fixed;
  z-index: 100000;
  margin: 0 0 auto auto;
  background: #00000078;
  padding: 100px 0 0 0;
  height: 100%;
} */

.navbar {
  display: none;
}

footer {
  display: none;
}

.paypro {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/support.vue